import { relationshipSummaryModel } from '~/models';
import { FilterType, filtersConfig } from '~/pages/AgreementsDashboard/agreementsDashboardFilters';
export const buildAgreementsCsvExportParams = (param)=>{
    let { search, filters } = param;
    const selected = filters === null || filters === void 0 ? void 0 : filters[FilterType.AgreementStatus];
    const wireStatuses = selected != null && selected.length > 0 ? selected.map(toWireStatus).join(',') : undefined;
    const params = {
        status: wireStatuses,
        search: search != null && search !== '' ? search : undefined
    };
    if (filters) {
        Object.entries(filtersConfig).forEach((param)=>{
            let [key, config] = param;
            if (key === FilterType.AgreementStatus) return;
            const value = filters[key];
            if (value == null || !config.hasValue(value)) return;
            Object.assign(params, config.getRequestParam(value));
        });
    }
    return params;
};
const toWireStatus = (value)=>{
    switch(value){
        case relationshipSummaryModel.AgreementStatus.Active:
            return 'active';
        case relationshipSummaryModel.AgreementStatus.Exhausted:
            return 'completed';
        case relationshipSummaryModel.AgreementStatus.Terminated:
            return 'terminated';
        default:
            {
                const _exhaustive = value;
                return _exhaustive;
            }
    }
};
